import {Component, Vue} from 'vue-property-decorator';
import {EventBus} from "@common/EventBus";
import {OnlineActivityParam} from "@service/store/types/OnlineActivityParam";

@Component
class OnlineCounter extends Vue {
	onlineUsersCount = 0;
	onlineCounterTake = 0;

	// Нужно переопределить в родительском компоненте
    get onlineUsersCounterId() {
        return "__";
    }

    setOnlineUsersCount() {
        const counter = this.$store.getters['onlineUsers/counter'](this.onlineUsersCounterId);
        this.onlineUsersCount = counter && counter.count
            ? counter.count
            : 0;
    }

    get counter() {
        return this.$store.getters['onlineUsers/counter'](this.onlineUsersCounterId);
    }

    // Подписка на обновление счетчиков
    // Вызывается вне mounted миксина, так как может требовать инициализацию данных родительского компонента
    async subscribeToOnlineUsersUpdate() {
        if (!this.$store.state.onlineUsers.needCounters) {
            return;
        }

        EventBus.$on('onlineUsers/generalCounterUpdated', this.setOnlineUsersCount);
        await this.$store.dispatch('onlineUsers/addActivity', { name: this.onlineUsersCounterId, take: this.onlineCounterTake } as OnlineActivityParam);
        await this.$store.dispatch('onlineUsers/update');
    }

    unsubscribeFromOnlineUsersUpdate() {
        EventBus.$off('onlineUsers/generalCounterUpdated', this.setOnlineUsersCount);
        this.$store.dispatch('onlineUsers/removeActivity', {name: this.onlineUsersCounterId, take: this.onlineCounterTake} as OnlineActivityParam);
    }
}

export {OnlineCounter}
